import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { PageHeader } from "@/widgets/page-header"
import { fetchTradingPartners, selectSocialMarketPartnersFirstLoad, selectSocialMarketPartnersSearchQuery } from "../model"
import { useEffect, useRef } from "react"
import { PartnersGrid } from "./partners-grid"
import { SocialMarketPartnersFilters } from "./social-market-partners-filters"

export const SocialMarketPartnersPage = () => {
    const isFirstRender = useRef(true)
    const isFirstLoad = useAppSelector(selectSocialMarketPartnersFirstLoad)
    const dispatch = useAppDispatch()
    const search = useAppSelector(selectSocialMarketPartnersSearchQuery)

    useEffect(() => {
        if (!isFirstRender.current) {
            dispatch(fetchTradingPartners())
        }
    }, [search])

    useEffect(() => {
        if (isFirstLoad) {
            dispatch(fetchTradingPartners())
        }
        isFirstRender.current = false
    }, [])

    return (
        <div className="_page_container flex-1">
            <PageHeader title="Маркет социальных программ" />
            <div className='flexbox h-full '>
                <PageSubtitle title="Партнеры" />
                <SocialMarketPartnersFilters />
                <PartnersGrid />
            </div>
        </div>
    )
}